module.exports = __webpack_public_path__ + "static/sheryl-sandberg-37cb1693f8841c4d587a00d60de320d1.jpg";